import { getTexts } from '@/api/api';
import { defineStore } from "pinia";
import { ref } from "vue";

export const useTextStore = defineStore("textStore", () => {
  const texts = ref<Record<string, string>>({});
  // Callers asking at the same time share one request: the order-edit page
  // reads its 71 texts at once. A failed or empty load is tried again by the
  // next caller, as before.
  let pending: Promise<void> | null = null;

  function ensureLoaded(): Promise<void> {
    if (Object.keys(texts.value).length > 0) return Promise.resolve();
    if (!pending) {
      pending = (async () => {
        const data = await getTexts();
        if (data?.success && data.data) {
          data.data.forEach(t => {
            texts.value[t.Id] = t.Texte;
          });
        }
      })().finally(() => {
        pending = null;
      });
    }
    return pending;
  }

  async function getText(id: string) {
    await ensureLoaded();
    return texts.value[id];
  }

  /** Every text (empty when the load failed). */
  async function getAll(): Promise<Record<string, string>> {
    await ensureLoaded();
    return { ...texts.value };
  }

  return { getText, getAll };
})
